import {Component, OnInit, Input, Inject} from '@angular/core';
import {Patient} from "./patient";
import {PatientsManagerService} from "../patients-manager.service";
import {ApiRequestService} from "../api-request.service";
import {Situation} from "./situation/situation";

@Component({
  selector: 'taxihandgo-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.scss']
})
export class PatientComponent implements OnInit {

  @Input() patient: Patient;
  showResponse: boolean = false;
  isLoading: boolean = false;
  situation: Situation;
  error: string;

  constructor(
    @Inject("apiRequest") private apiRequest: ApiRequestService
  ) { }

  ngOnInit() {
  }

  send(){
    this.showResponse = true;
    this.isLoading = true;
    this.situation = null;
    this.error = null;

    this.apiRequest.getPecplus([PatientsManagerService.makeJSON(this.patient)])
      .subscribe(
        res => {
          for (let k = 0; k < res.length; ++k){
            if (res[k].error){
              this.error = res[k].error;
              break;
            }
            
            let situation = Situation.create(res[k]);
            if (situation.nir.equalsTo(this.patient.nir)){
              this.situation = situation;
              break;
            }
          }
          this.isLoading = false;
        },
        err => {
          console.log(err);
          this.isLoading = false;
        }
      );
  }

  write(){
    this.showResponse = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/patient/patient.component.ts